import { render, staticRenderFns } from "./routeSopDashboard.vue?vue&type=template&id=e4c32a2a"
import script from "./routeSopDashboard.vue?vue&type=script&lang=js"
export * from "./routeSopDashboard.vue?vue&type=script&lang=js"
import style0 from "./routeSopDashboard.vue?vue&type=style&index=0&id=e4c32a2a&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports